import React from 'react';
import { BRUTO_RULE_START_LABEL } from '../utils/bruto';

// Bruto display/edit. Locked to Neto for entries dated before 01/09/2026.
export default function BrutoCell({ entry, editing, locked, value, neto, overridden, onChange }) {
  if (editing && !locked) {
    const bruto = Number(value);
    const below = Number.isFinite(bruto) && bruto < Number(neto);
    return (
      <div>
        <input
          type="number"
          step="0.5"
          min="0"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          aria-label="Bruto hours"
          className="w-20 text-right text-sm font-semibold tabular text-ink bg-surface border border-line-strong rounded-tc-sm px-2 py-2 min-h-[44px]"
        />
        {overridden && <div className="text-[10px] font-semibold uppercase tracking-wider text-state-review-fg">manual</div>}
        {overridden && (
          <p className="text-[11px] text-state-review-fg">A manual Bruto is recalculated when Neto changes.</p>
        )}
        {below && <p className="text-[11px] text-state-review-fg">Bruto is lower than Neto.</p>}
      </div>
    );
  }

  const shown = editing ? value : entry.hours_bruto;
  const display = shown === null || shown === undefined || shown === '' ? Number(entry.hours || 0) : Number(shown);
  return (
    <div>
      <span className={`font-semibold tabular ${locked ? 'text-muted' : 'text-accent'}`}>{display.toFixed(1)}</span>
      {!editing && Boolean(entry.bruto_overridden) && (
        <div className="text-[10px] font-semibold uppercase tracking-wider text-state-review-fg">manual</div>
      )}
      {locked && (
        <div className="text-[10px] font-semibold uppercase tracking-wider text-faint" title={`The Bruto/Neto rule applies from ${BRUTO_RULE_START_LABEL}`}>
          before {BRUTO_RULE_START_LABEL}
        </div>
      )}
    </div>
  );
}
